var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerCorrectImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 8.18384,
    cy: 8.75684,
    r: 8,
    fill: "#8DCD53"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.96606 9.79701L6.67749 12.5084L12.848 6.33789",
    stroke: "#EBFFDA",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerCorrectImage);
export default __webpack_public_path__ + "static/media/PlayerCorrectImage.7caf2e6f9eba9b583c74b038885acf47.svg";
export { ForwardRef as ReactComponent };